import FieldHtmlNameUtil from '../FieldHtmlNameUtil';
import HekateFormElementDefinition from '../HekateForm/HekateFormElementDefinition';
import HekateOptionList from '../HekateForm/HekateOptionList';
class HekateDisplayField extends HekateFormElementDefinition {
    get componentName() {
        return this._innerComponentName;
    }
    set componentName(n) {
        this._innerComponentName = n;
        if (n !== 'hidden-field') {
            this.previousComponentName = n;
        }
    }
    constructor({ id, name, dataType, displayType, displayVariantType, htmlName, optionListId, optionList, validations, label, }) {
        super({
            dataType,
            displayType,
            displayVariantType,
            htmlName,
            id,
            name,
            optionListId,
            optionList,
            validations,
        });
        this.componentKey = Math.floor((1 << 30) * Math.random()).toString(16);
        this.val = displayType === 'checkbox' ? false : '';
        this.isRequired =
            validations && !!validations.find((validation) => validation.name === 'IsRequiredCondition');
        const componentName = HekateDisplayField.getComponentName({ displayType, htmlName });
        this._innerComponentName = componentName;
        this.initialComponentName = componentName;
        this.previousComponentName = componentName;
        this.errorMessages = [];
        this.isValidated = false;
        this.interactiveState = 'untouched';
        this.isIgnorePrefillAndEventBusValues = false;
        this.isDisabled = false;
        this.label = label;
    }
    /** Create a new refreshed componentKey to be used in `<component :key="field.componentKey">` */
    notifyChange() {
        this.componentKey = Math.floor((1 << 30) * Math.random()).toString(16);
    }
    /** shuffle the order of the option lists (but don't change the first element's order) */
    shuffleOptionList() {
        this.optionList.shuffleElements();
        return this;
    }
    static newHiddenFieldInstance({ id, htmlName }) {
        return new HekateDisplayField({
            id,
            htmlName,
            name: htmlName,
            dataType: 'text',
            displayType: 'hidden',
            displayVariantType: '',
            optionListId: '',
            optionList: HekateOptionList.newEmptyList(),
            validations: [],
        });
    }
    static newHintFieldInstance({ name }) {
        HekateDisplayField.idCount += 1;
        const id = `hint-id-${HekateDisplayField.idCount}`;
        return new HekateDisplayField({
            id,
            htmlName: 'hint',
            name,
            dataType: 'text',
            displayType: 'form-field-group',
            displayVariantType: '',
            optionListId: '',
            optionList: HekateOptionList.newEmptyList(),
            validations: [],
        });
    }
    /** Get the name of the component that will render this field */
    static getComponentName({ displayType, htmlName, }) {
        if (this.autoCompleteFieldHtmlNames.includes(htmlName)) {
            return 'auto-complete-field';
        }
        if (this.phoneNumberFieldHtmlNames.includes(htmlName)) {
            return 'phone-number-field';
        }
        switch (displayType) {
            case 'text':
                return 'text-input-field';
            case 'singleSelect':
                return 'single-select-field';
            case 'hidden':
                return 'hidden-field';
            case 'submit':
                return 'submit-field';
            case 'checkbox':
                return 'checkbox-field';
            case 'textArea':
                return 'textarea-field';
            case 'form-field-group':
                return 'readonly-description-field';
            case 'multiSelect':
                return 'multi-select-field';
            case 'recaptcha':
                return 'recaptcha-field';
            case 'age-verification':
                return 'age-verification-field';
            default:
                console.log('unsupported!', displayType);
                return 'unsupported-field';
        }
    }
}
/** list of field names that are converted to autocomplete */
HekateDisplayField.autoCompleteFieldHtmlNames = [
    FieldHtmlNameUtil.schoolName,
    FieldHtmlNameUtil.investorName,
];
/** list of field names that are converted to phone numbers */
HekateDisplayField.phoneNumberFieldHtmlNames = [FieldHtmlNameUtil.phoneNumber];
HekateDisplayField.idCount = 0;
export default HekateDisplayField;
